/* eslint-disable max-len */
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment-timezone';
// 1. `formatTimestamp(timestamp)` - uses default format
// 2. `formatTimestamp(timestamp, timezone)` - uses timezone with default format
// 3. `formatTimestamp(timestamp, timezone, 'YYYY-MM-DD HH:mm:ss')` - uses custom format with timezone
// 4. `formatTimestamp(timestamp, null, 'YYYY-MM-DD')` - uses custom format without timezone

function formatTimestamp(timestamp, timezone, format = 'h:mm A MMM D, YYYY') {
  if (timestamp !== null && timestamp !== undefined) {
    // Convert to number if string and validate it's a valid number
    const timestampNum = Number(timestamp);
    if (Number.isNaN(timestampNum)) {
      return '';
    }

    try {
      if (timezone) {
        return moment.unix(timestampNum).tz(timezone).format(format);
      }
      return moment.unix(timestampNum).format(format);
    } catch (error) {
      return '';
    }
  }
  return '';
}

export default formatTimestamp;
